module.exports = __webpack_public_path__ + "img/shimaguni-flyer-front.b6a4c470.jpg";